'use client';
export let Colours = /*#__PURE__*/function (Colours) {
  Colours["Red"] = "red";
  Colours["Orange"] = "orange";
  Colours["Yellow"] = "yellow";
  Colours["Green"] = "green";
  Colours["Cyan"] = "cyan";
  Colours["Blue"] = "blue";
  Colours["Violet"] = "violet";
  return Colours;
}({});

// Define available shade values

// Basic color type without shades

// Color with shade type (e.g., red.50, blue.500)

// Combined type that allows both basic colors and colors with shades